export default __webpack_public_path__ + "static/haleon_bw-fb5a1c33389338c5174f7eb90b4c2f86.png";